import { getSupportedLocale } from '@ms/yammer-i18n';
import type { Action, Dispatch } from 'redux';

import type { Locale, YammerI18nState } from '../../state/types';

import { getCurrentLocale } from './selectors';

export interface LocaleSetAction extends Action {
  readonly type: '@@yammer-i18n-react/LOCALE.SET';
  readonly payload: Locale;
}

type SetLocale = (locale: Locale) => LocaleSetAction;

export const setLocale: SetLocale = (locale) => {
  const supportedLocale = getSupportedLocale(locale);

  return {
    type: '@@yammer-i18n-react/LOCALE.SET',
    payload: supportedLocale,
  };
};

type SetLocaleFromBrowser = <S extends YammerI18nState>(dispatch: Dispatch, state: S, overrideLocale?: Locale) => void;
export const setLocaleFromBrowser: SetLocaleFromBrowser = (dispatch, state, overrideLocale) => {
  const currentLocale = getCurrentLocale(state);
  if (currentLocale) {
    return;
  }

  const locale = overrideLocale || window.navigator.language;
  dispatch(setLocale(locale));
};
